import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getSeanceReports(params: any): AxiosPromise {
    return EndPointService.get('/occasion-reports', { params });
}

function getSeanceReport(id: number | string): AxiosPromise {
    return EndPointService.get(`/seanceReports/${id}`);
}

function deleteSeanceReport(id: number | string): AxiosPromise {
    return EndPointService.delete(`/seanceReports/${id}`);
}

function createSeanceReport(payload: any): AxiosPromise {
    return EndPointService.post('/seanceReports', payload);
}

function updateSeanceReport(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/seanceReports/${id}`, { ...payload });
}

export default {
    getSeanceReports,
    getSeanceReport,
    deleteSeanceReport,
    createSeanceReport,
    updateSeanceReport,
};
